import { gql } from 'urql';

const gqlQuery = gql`
  query V2ARecipients($after: String, $first: Int) {
    v2aRecipients(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          displayName
          phoneNumber
          email {
            address
          }
          ... on V2AInternalRecipient {
            name {
              initials
              full
              first
              last
            }
          }
          __typename
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export default gqlQuery;
